import * as StateLib from "@/Utils/StateLib";
import React, { Fragment } from "react";
import { ToolIcon, Menu, ColorTrigger } from "@theorgchartdev/storybook";
import CompositeColorPicker from "../../../Blocks/Composites/CompositeColorPicker/CompositeColorPicker";
import { getHoverTipContent } from "@/Utils/Misc";
import {
  BuildLineStyleOptions,
  BuildBorderWeightOptions,
  BuildLineSubGroupOptions
} from "../ToolbarOptions";
import { appstr } from "@coreapp/utils/appstr";
import { enumUpdateProperty, enumFillMode } from "@coreapp/constants";
import { QColorPickerResult } from "@coreapp/CoreApp/QColorPickerResult";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const LineToolsComposite = () => {
  let wsMgr = StateLib.GetWSMgr();
  let lineWeight;
  let lineDash;
  let lineSubDash;
  let lineColor;

  if (wsMgr) {
    lineWeight = wsMgr.SurveySelection(enumUpdateProperty.connectingLineThickness);
    lineDash = wsMgr.SurveySelection(enumUpdateProperty.connectingLineDash);
    lineSubDash = wsMgr.SurveySelection(enumUpdateProperty.subGroupLineDash);
    let lineColorCP = wsMgr.SurveySelection(enumUpdateProperty.connectingLineColor);
    if (lineColorCP) lineColor = lineColorCP.fSelectedColor;
  }

  const lineWeightTrigger = (
    <ToolIcon
      name={"lines-regular"}
      title={appstr("Line weight")}
      tooltipProps={getHoverTipContent("linethickness")}
    />
  );

  const lineWeightOptions = BuildBorderWeightOptions(UpdateLineWeight);

  const lineStyleTrigger = (
    <ToolIcon
      name={"border-top-left"}
      title={appstr("Line style")}
      tooltipProps={getHoverTipContent("linethickness")}
    />
  );

  const lineStyleOptions = BuildLineStyleOptions(UpdateLineDash);

  const lineSubDashTrigger = (
    <ToolIcon
      name={"border-all"}
      title={appstr("Line subgroup style")}
      tooltipProps={getHoverTipContent("linepattern")}
    />
  );
  const lineSubOptions = BuildLineSubGroupOptions(UpdateLineSubDash);

  return (
    <Fragment>
      <Menu
        dataTestId={editModeTestId("line-weight-menu")}
        trigger={lineWeightTrigger}
        options={lineWeightOptions}
        value={lineWeight}
      />
      <Menu
        dataTestId={editModeTestId("line-style-menu")}
        trigger={lineStyleTrigger}
        options={lineStyleOptions}
        value={lineDash}
      />
      <Menu
        dataTestId={editModeTestId("line-subgroup-style-menu")}
        trigger={lineSubDashTrigger}
        options={lineSubOptions}
        value={lineSubDash}
      />
      <CompositeColorPicker
        dataTestId={editModeTestId("line-color")}
        trigger={
          <ColorTrigger
            iconName="pen-line"
            size={"small"}
            tooltipProps={{ message: appstr("Connecting Line Color") }}
          />
        }
        onChange={UpdateLineColor}
        currentColor={lineColor}
      />
    </Fragment>
  );
};

const UpdateLineWeight = target => {
  const newLineWeight = target.value;
  StateLib.UpdateBoxProperty(enumUpdateProperty.connectingLineThickness, newLineWeight);
};

const UpdateLineDash = target => {
  const newLineDash = target.value;
  StateLib.UpdateBoxProperty(enumUpdateProperty.connectingLineDash, newLineDash);
};

const UpdateLineColor = selectedLineColor => {
  //const newLineDash = target.value;
  let color = new QColorPickerResult();
  color.fSelectedColor = selectedLineColor;
  color.fFillMode = selectedLineColor ? enumFillMode.solidFill : enumFillMode.noFill;
  StateLib.UpdateBoxProperty(enumUpdateProperty.connectingLineColor, color);
};

const UpdateLineSubDash = target => {
  const newSubLineDash = target.value;
  StateLib.UpdateBoxProperty(enumUpdateProperty.subGroupLineDash, newSubLineDash);
};

export default LineToolsComposite;
